import React, { useEffect, useState, useRef } from "react";

import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Contactform } from "./components/Contactform";
import { Numbers } from "./components/Numbers";
import Slider from "react-slick";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import img01 from "./images/banner01.webp";
import img02 from "./images/banner02.webp";
import img03 from "./images/banner03.webp";
import img04 from "./images/banner_04.png";
import img05 from "./images/Router.webp";
import img06 from "./images/home_banner_05.webp";
import utubebanner from "./images/utubebanner.jpeg";
import Banner01 from "./images/banner01.jpg";
import Banner02 from "./images/Banner02.jpg";
import Banner03 from "./images/Banner03.jpg";
import Banner04 from "./images/Banner04.jpg";
import Banner05 from "./images/Banner05.jpg";
import Banner06 from "./images/Banner06.jpg";
import BannerMobile01 from "./images/Banner01m.jpg";
import BannerMobile02 from "./images/Banner02m.jpg";
import BannerMobile03 from "./images/Banner03m.jpg";
import BannerMobile04 from "./images/Banner04m.jpg";
import BannerMobile05 from "./images/Banner05m.jpg";
import BannerMobile06 from "./images/Banner06m.jpg";
import utubebannerm from "./images/utubebannerm.jpeg";
import img14 from "./images/Iptv3.png";
import img15 from "./images/banner 1_2.webp";
import img07 from "./images/slider-banner-6-1.png";
import img08 from "./images/jeeveshu.webp";
import img10 from "./images/ott_banner.webp";
import img11 from "./images/jeeveshu2.webp";
import img12 from "./images/ott_Bann_01.webp";
import img13 from "./images/banner11.webp";
import img16 from "./images/smart_tv3.png";
import img17 from "./images/banner011.png";
import img20 from "./images/2iptv-22.png";
import img18 from "./images/FW+.webp";
import Service01 from "./images/broadband.webp";
import Service02 from "./images/voice.webp";
import Service03 from "./images/enterprise.webp";
import Service04 from "./images/android-tv-box.webp";
import Service05 from "./images/cloud-service.png";
import App from "./images/Reacharge.webp";
import Feature01 from "./images/Feature_img_01.webp";
import Feature02 from "./images/Feature_img_02.webp";
import Feature03 from "./images/Feature_img_3.webp";
import Feature04 from "./images/Feature_img_4.webp";
import Tech01 from "./images/cisco.webp";
import Tech02 from "./images/dell.webp";
import Tech03 from "./images/genexis.webp";
import Tech04 from "./images/tech04.webp";
import Tech05 from "./images/netapp.webp";
import Tech06 from "./images/tech06.webp";
import Tech07 from "./images/nokia.webp";
import Tech08 from "./images/zte.webp";
import Tech09 from "./images/alphion.png";
import Speed from "./images/2xspeed.webp";
import { Broadband } from "./components/Broadband";
import { Entertainment } from "./components/Entertainment";
import { Link } from "react-router-dom";
import Popupimg1 from "./images/CEWTariffBillingBanner_Q2.png";
import Popupimg1Mobile from "./images/CEWTariffBillingBanner.png";
// import Popupimg1 from "./images/pb1.jpeg";
// import Popupimg2 from "./images/pb2.jpeg";
import Mimg05 from "./images/Mimg05.webp";
import { Jujharcont } from "./components/Jujharcont";
import PromoBanner from "./images/independence.jpeg";
import PromoBanner1 from "./images/patiala_event.jpeg";

export const Home = () => {
  const [popupStep, setPopupStep] = useState(1); // 1 = first popup, 2 = second popup, 0 = closed

  const closePopup1 = () => setPopupStep(2);
  const closePopup2 = () => setPopupStep(0);
  const [field, setfield] = useState("");

  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const VIDEO_ID = "n_BhXFG5MaE";

  const [videoOpen, setVideoOpen] = useState(false);

  useEffect(() => {
    if (!videoOpen) return;
    const onKey = (e) => e.key === "Escape" && setVideoOpen(false);
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [videoOpen]);
  function handleRadioChange(event) {
    setfield(event.target.value);
  }
  function handleButtonClick() {
    const clickedVal = field;
    if (clickedVal === "") {
      alert("Please select any plan");
      return false;
    } else if (clickedVal === "retail") {
      window.location.href = "retail/#broadband";
    } else {
      window.location.href = "ip-tv";
    }
  }

  var settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: !videoOpen,
    speed: 800,
    autoplaySpeed: 3500,
    arrows: false,
    cssEase: "ease-in-out",
    centerMode: true,
    centerPadding: "150px", // controls how much of prev/next peeks in
  };
  var settingsMobile = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: !videoOpen,
    speed: 800,
    autoplaySpeed: 3500,
    arrows: false,
    cssEase: "ease-in-out",
    centerMode: true,
    centerPadding: "80px",
    responsive: [
      {
        breakpoint: 480,
        settings: {
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 360,
        settings: {
          centerPadding: "12px",
        },
      },
    ],
  };
  var settings2 = {
    dots: false,
    navigation: true,
    loop: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    speed: 300,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1340,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      {/* Popup Start 

      {popupStep === 1 && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.7)",
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "85%",
              maxWidth: "900px",
            }}
          >
            <button
              onClick={closePopup1}
              className="popup-close-btn"
              style={{
                position: "absolute",
                top: "-16px",
                background: "#fff",
                border: "none",
                borderRadius: "50%",
                width: "34px",
                height: "34px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor: "pointer",
                zIndex: 10,
                lineHeight: "34px",
                textAlign: "center",
                boxShadow: "0 2px 6px rgba(0,0,0,0.4)",
              }}
            >
              ✕
            </button>

            <picture>
      
              <source
                media="(max-width: 767px)"
                srcSet={encodeURI(`${Popupimg1Mobile}?v=2`)}
              />

           
              <img
                src={`${Popupimg1}?v=2`}
                alt="Promo"
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "75vh",
                  objectFit: "contain",
                  borderRadius: "10px",
                  display: "block",
                }}
              />
            </picture>
          </div>
        </div>
      )}

      {/* Popup End */}

      {/* Video modal */}
      {videoOpen && (
        <div
          onClick={() => setVideoOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.85)",
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
            boxSizing: "border-box",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ position: "relative", width: "100%", maxWidth: 960 }}
          >
            <button
              type="button"
              aria-label="Close video"
              onClick={() => setVideoOpen(false)}
              style={{
                position: "absolute",
                top: -40,
                right: 0,
                background: "transparent",
                border: "none",
                color: "#fff",
                fontSize: 32,
                lineHeight: 1,
                cursor: "pointer",
              }}
            >
              ✕
            </button>
            <div style={{ position: "relative", paddingTop: "56.25%" }}>
              <iframe
                src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
                title="Netplus video"
                allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
                allowFullScreen
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                  borderRadius: 12,
                }}
              />
            </div>
          </div>
        </div>
      )}

      {/* Click-here button animations */}
      <style>{`
        @keyframes nplsPulse {
          0%   { box-shadow: 0 0 0 0 rgba(255,255,255,0.55); }
          100% { box-shadow: 0 0 0 24px rgba(255,255,255,0); }
        }
        @keyframes nplsNudge {
          0%, 100% { transform: translateY(0); }
          50%      { transform: translateY(10px); }
        }
        @keyframes nplsNudgeX {
  0%, 100% { transform: translateX(0); }
  50%      { transform: translateX(5px); }
}
@keyframes nplsPulseSm {
  0%   { box-shadow: 0 0 0 0 rgba(255,255,255,0.55); }
  100% { box-shadow: 0 0 0 10px rgba(255,255,255,0); }
}
        .npls-video-cta:hover .npls-play { background: rgba(255,255,255,0.3); }
      `}</style>

      <Header />

      {/* {showModal && (
  <div className="modal-overlay">
    <div className="modal-content">
      <button className="close-button" onClick={handleClose}>×</button>
      <img src={PromoBanner1} alt="Promotional Banner" className="promo-banner" />
    </div>
  </div>
)} */}

      <section
        id="banner"
        className="p-0 hbanner newbanner"
        data-aos="fade-left"
        data-aos-offset="200"
        data-aos-duration="600"
        data-aos-once="true"
        data-aos-easing="ease-in-sine"
      >
        <div
          style={{
            width: "100%",
            position: "relative",
            marginTop: "120px",
            padding: "0 10px",
            boxSizing: "border-box",
          }}
        >
          {/* Desktop Slider */}
          <div className="banner-desktop">
            <Slider {...settings}>
              {[
                utubebanner,
                Banner01,
                Banner02,
                Banner03,
                Banner04,
                Banner05,
                Banner06,
              ].map((banner, index) => (
                <div key={index} style={{ padding: "0 8px" }}>
                  <div style={{ position: "relative", lineHeight: 0 }}>
                    <img
                      src={banner}
                      alt={`Banner ${index + 1}`}
                      loading={index === 0 ? "eager" : "lazy"}
                      decoding="async"
                      fetchPriority={index === 0 ? "high" : "auto"}
                      draggable={false}
                      style={{
                        width: "100%",
                        display: "block",
                        objectFit: "cover",
                        borderRadius: "20px",
                      }}
                    />

                    {index === 0 && (
                      <button
                        type="button"
                        aria-label="Click here to watch video"
                        className="npls-video-cta"
                        onClick={() => setVideoOpen(true)}
                        style={{
                          position: "absolute",
                          top: "42%",
                          right: "30%",
                          transform: "translateX(50%)",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 6,
                          background: "transparent",
                          border: "none",
                          padding: 0,
                          cursor: "pointer",
                          lineHeight: 1,
                        }}
                      >
                        <span
                          style={{
                            color: "#fff",
                            fontSize: 18,
                            fontWeight: 700,
                            letterSpacing: 0.8,
                            textTransform: "uppercase",
                            textShadow: "0 2px 6px rgba(0,0,0,0.35)",
                          }}
                        >
                          Click here
                        </span>

                        <svg
                          width="24"
                          height="37"
                          viewBox="0 0 28 44"
                          fill="none"
                          stroke="#fff"
                          strokeWidth="3.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          style={{
                            animation: "nplsNudge 1s ease-in-out infinite",
                          }}
                        >
                          <path d="M14 3v36" />
                          <path d="M4 29l10 11 10-11" />
                        </svg>

                        <span
                          className="npls-play"
                          style={{
                            width: 64,
                            height: 64,
                            borderRadius: "50%",
                            border: "2px solid rgba(255,255,255,0.8)",
                            background: "rgba(255,255,255,0.18)",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            animation: "nplsPulse 1.6s ease-out infinite",
                            transition: "background 0.2s",
                          }}
                        >
                          <svg
                            width="29"
                            height="29"
                            viewBox="0 0 24 24"
                            fill="#fff"
                          >
                            <path d="M8 5v14l11-7z" />
                          </svg>
                        </span>
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          {/* Mobile Slider */}
          {/* Mobile Slider */}
          <div className="banner-mobile">
            <Slider {...settingsMobile}>
              {[
                utubebannerm,
                BannerMobile01,
                BannerMobile02,
                BannerMobile03,
                BannerMobile04,
                BannerMobile05,
                BannerMobile06,
              ].map((banner, index) => (
                <div key={index} style={{ padding: "0 8px" }}>
                  <div style={{ position: "relative", lineHeight: 0 }}>
                    <img
                      src={banner}
                      alt={`Banner ${index + 1}`}
                      loading={index === 0 ? "eager" : "lazy"}
                      decoding="async"
                      fetchPriority={index === 0 ? "high" : "auto"}
                      draggable={false}
                      style={{
                        width: "100%",
                        display: "block",
                        objectFit: "cover",
                        borderRadius: "20px",
                      }}
                    />

                    {index === 0 && (
                      <button
                        type="button"
                        aria-label="Click here to watch video"
                        className="npls-video-cta"
                        onClick={() => setVideoOpen(true)}
                        style={{
                          position: "absolute",
                          top: "28%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 8,
                          background: "transparent",
                          border: "none",
                          padding: 0,
                          cursor: "pointer",
                          lineHeight: 1,
                          whiteSpace: "nowrap",
                        }}
                      >
                        <span
                          style={{
                            color: "#fff",
                            fontSize: 13,
                            fontWeight: 700,
                            letterSpacing: 0.6,
                            textTransform: "uppercase",
                            textShadow: "0 2px 6px rgba(0,0,0,0.35)",
                          }}
                        >
                          Click here
                        </span>

                        <svg
                          width="24"
                          height="14"
                          viewBox="0 0 46 28"
                          fill="none"
                          stroke="#fff"
                          strokeWidth="3.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          style={{
                            animation: "nplsNudgeX 1s ease-in-out infinite",
                          }}
                        >
                          <path d="M3 14h38" />
                          <path d="M30 4l11 10-11 10" />
                        </svg>

                        <span
                          className="npls-play"
                          style={{
                            width: 34,
                            height: 34,
                            minWidth: 34,
                            minHeight: 34,
                            flexShrink: 0,
                            boxSizing: "border-box",
                            borderRadius: "50%",
                            border: "2px solid rgba(255,255,255,0.8)",
                            background: "rgba(255,255,255,0.18)",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            animation: "nplsPulseSm 1.6s ease-out infinite",
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="#fff"
                            style={{ flexShrink: 0 }}
                          >
                            <path d="M8 5v14l11-7z" />
                          </svg>
                        </span>
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>

      <section id="chooseplan">
        <div className="container">
          <div className="row">
            <div
              className="chooseplan bgcolor1"
              data-aos="fade-up"
              data-aos-offset="100"
              data-aos-duration="600"
              data-aos-once="true"
              data-aos-easing="ease-in-sine"
            >
              <div className="web-container">
                <div className="title">
                  <h3>Your net. Your plan.</h3>
                </div>
                <div className="containers">
                  <input
                    type="radio"
                    name="field"
                    id="Uno"
                    value="retail"
                    checked={field === "retail"}
                    onChange={handleRadioChange}
                  />
                  <label htmlFor="Uno">
                    <svg className="check" viewBox="0 0 60 60">
                      <defs>
                        <linearGradient
                          id="gradient"
                          x1="0"
                          y1="0"
                          x2="0"
                          y2="100%"
                        >
                          <stop offset="0%" stopColor="#ff8a00"></stop>
                          <stop offset="100%" stopColor="#da1b60"></stop>
                        </linearGradient>
                      </defs>
                      <circle id="border" r="18px" cx="20px" cy="20px"></circle>
                      <circle id="dot" r="8px" cx="20px" cy="20px"></circle>
                    </svg>
                    Broadband
                  </label>

                  <input
                    type="radio"
                    name="field"
                    id="Dos"
                    value="ip-tv"
                    checked={field === "ip-tv"}
                    onChange={handleRadioChange}
                  />
                  <label htmlFor="Dos">
                    <svg className="check" viewBox="0 0 60 60">
                      <defs>
                        <linearGradient
                          id="gradient"
                          x1="0"
                          y1="0"
                          x2="0"
                          y2="100%"
                        >
                          <stop offset="0%" stopColor="#ff8a00"></stop>
                          <stop offset="100%" stopColor="#da1b60"></stop>
                        </linearGradient>
                      </defs>
                      <circle id="border" r="18px" cx="20px" cy="20px"></circle>
                      <circle id="dot" r="8px" cx="20px" cy="20px"></circle>
                    </svg>
                    IPTV
                  </label>
                </div>
                <div className="butn">
                  <div className="buttnprop" onClick={handleButtonClick}>
                    <span>Explore Plans</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="service">
        <div className="service">
          <div className="container">
            <div className="row">
              <div
                className="title"
                data-aos="fade-up"
                data-aos-offset="100"
                data-aos-duration="600"
                data-aos-once="true"
                data-aos-easing="ease-in-sine"
              >
                <span>Our Services</span>
                <h3>Get connected. Glitch free.</h3>
              </div>
              <div
                className="netpluslide"
                data-aos="fade-up"
                data-aos-offset="200"
                data-aos-duration="600"
                data-aos-once="true"
                data-aos-easing="ease-in-sine"
              >
                <Slider {...settings2}>
                  <div>
                    <div className="servicebox">
                      <div className="serviceimg">
                        <img src={Service01} alt="" />
                      </div>
                      <div className="servicecont">
                        <h4>BROADBAND</h4>
                        <p>
                          Unlimited internet at the speed of up to 1000 Mbps
                        </p>
                        <div className="butn">
                          <div className="buttnprop">
                            <Link to="/retail">
                              <span>Know More</span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div>
                    <div className="servicebox">
                      <div className="serviceimg">
                        <img src={Service05} alt="" />
                      </div>
                      <div className="servicecont">
                        <h4>SECURE CLOUD STORAGE</h4>
                        <p>Store your files and documents in a secure cloud.</p>
                        <div className="butn">
                          <div className="buttnprop">
                            <Link to="/cloud-storage">
                              <span>Know More</span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <div>
                    <div className="servicebox">
                      <div className="serviceimg">
                        <img src={Service02} alt="" />
                      </div>
                      <div className="servicecont">
                        <h4>VOICE</h4>
                        <p>
                          Enhance your voice experience on STD and local calls
                          with Netplus smart telephony
                        </p>
                        <div className="butn">
                          <div className="buttnprop">
                            <Link to="/voice">
                              <span>Know More</span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="servicebox">
                      <div className="serviceimg">
                        <img src={Service04} alt="" />
                      </div>
                      <div className="servicecont">
                        <h4>IPTV BOX</h4>
                        <p>Revolutionize your viewing with FW+</p>
                        <div className="butn">
                          <div className="buttnprop">
                            <Link to="/ip-tv">
                              <span>Know More</span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="servicebox">
                      <div className="serviceimg">
                        <img src={Service03} alt="" />
                      </div>
                      <div className="servicecont">
                        <h4>ENTERPRISE</h4>
                        <p>
                          Enterprise business solutions with internet leased
                          line
                        </p>
                        <div className="butn">
                          <div className="buttnprop">
                            <Link to="/enterprise">
                              <span>Know More</span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div>
                    <div className="servicebox">
                      <div className="serviceimg">
                        <img src={Service01} alt="" />
                      </div>
                      <div className="servicecont">
                        <h4>NETPLUS HD BUNDLE</h4>
                        <p>
                          Netplus Live HD Streaming with unlimited data/calls
                          and OTT subscription under one plan
                        </p>
                        <div className="butn">
                          <div className="buttnprop">
                            <Link to="/netplus-hd-bundle">
                              <span>Know More</span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="app">
        <div className="app">
          <div className="container">
            <div className="row">
              <div className="gradientapp">
                <div
                  className="appleft"
                  data-aos="fade-left"
                  data-aos-offset="200"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <div className="appbox">
                    <h3>
                      Pay. Recharge. <br /> In just one click.
                    </h3>
                    <div className="appcta">
                      <span>
                        <Link to="/pay-bill">Pay Bills / Recharge</Link>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="apprgt ">
                  <div
                    className="appimg"
                    data-aos="fade-up"
                    data-aos-offset="200"
                    data-aos-duration="600"
                    data-aos-once="true"
                    data-aos-easing="ease-in-sine"
                  >
                    <img src={App} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="plans">
        <div
          className="plans"
          data-aos="fade-up"
          data-aos-offset="200"
          data-aos-duration="600"
          data-aos-once="true"
          data-aos-easing="ease-in-sine"
        >
          <div className="container">
            <div className="row">
              <div className="planstab">
                <Tabs>
                  <TabList>
                    <Tab>BROADBAND PLANS</Tab>
                    {/* <Tab>ENTERTAIMENT PLANS</Tab> */}
                  </TabList>
                  <TabPanel>
                    <div className="planstabpanel">
                      <div className="title">
                        <h3>Your need. Your choice.</h3>
                      </div>
                      <Broadband />
                    </div>
                  </TabPanel>
                  <TabPanel>
                    {/* <div className="planstabpanel">
                      <div className="title">
                        <h3>Your need. Your choice.</h3>
                      </div>
                      <Entertainment />
                    </div> */}
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="feature">
        <div className="feature">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div
                  className="title"
                  data-aos="fade-up"
                  data-aos-offset="200"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <span>Features</span>
                  <h3>Stay ahead. With double the speed.</h3>
                </div>
                <div className="featurestn">
                  <div className="featurerow">
                    <div
                      className="feartureimg"
                      data-aos="fade-left"
                      data-aos-offset="200"
                      data-aos-duration="600"
                      data-aos-once="true"
                      data-aos-easing="ease-in-sine"
                    >
                      <img src={Feature01} alt="" />
                    </div>
                    <div
                      className="featurecont"
                      data-aos="fade-right"
                      data-aos-offset="200"
                      data-aos-duration="600"
                      data-aos-once="true"
                      data-aos-easing="ease-in-sine"
                    >
                      <div className="featurebox">
                        <span>1</span>
                        <div className="featureInfo">
                          <h4>High speed Internet</h4>
                          <p>Explore at lightning fast speed</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="featurerow">
                    <div
                      className="feartureimg"
                      data-aos="fade-left"
                      data-aos-offset="200"
                      data-aos-duration="600"
                      data-aos-once="true"
                      data-aos-easing="ease-in-sine"
                    >
                      <img src={Feature02} alt="" />
                    </div>
                    <div
                      className="featurecont"
                      data-aos="fade-right"
                      data-aos-offset="200"
                      data-aos-duration="600"
                      data-aos-once="true"
                      data-aos-easing="ease-in-sine"
                    >
                      <div className="featurebox">
                        <span>2</span>
                        <div className="featureInfo">
                          <h4>Reliability</h4>
                          <p>Trusted by majority of users in Punjab.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="featurerow">
                    <div
                      className="feartureimg"
                      data-aos="fade-left"
                      data-aos-offset="200"
                      data-aos-duration="600"
                      data-aos-once="true"
                      data-aos-easing="ease-in-sine"
                    >
                      <img src={Feature03} alt="" />
                    </div>
                    <div
                      className="featurecont"
                      data-aos="fade-right"
                      data-aos-offset="200"
                      data-aos-duration="600"
                      data-aos-once="true"
                      data-aos-easing="ease-in-sine"
                    >
                      <div className="featurebox">
                        <span>3</span>
                        <div className="featureInfo">
                          <h4>Entertainment packages</h4>
                          <p>
                            Get exciting combo deals for TV, Calling and
                            broadband.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="featurerow">
                    <div
                      className="feartureimg"
                      data-aos="fade-left"
                      data-aos-offset="200"
                      data-aos-duration="600"
                      data-aos-once="true"
                      data-aos-easing="ease-in-sine"
                    >
                      <img src={Feature04} alt="" />
                    </div>
                    <div
                      className="featurecont"
                      data-aos="fade-right"
                      data-aos-offset="200"
                      data-aos-duration="600"
                      data-aos-once="true"
                      data-aos-easing="ease-in-sine"
                    >
                      <div className="featurebox">
                        <span>4</span>
                        <div className="featureInfo">
                          <h4>Affordable pricing</h4>
                          <p>Entertainment is 2X when you pay less.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="number" className="pt-0">
        <div className="number">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div
                  className="title"
                  data-aos="fade-up"
                  data-aos-offset="200"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <h3>Your No.1 broadband</h3>
                </div>
                <Numbers />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="technology">
        <div className="technologystn">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div
                  className="title"
                  data-aos="fade-up"
                  data-aos-offset="200"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <h3>Our Technological Marvels.</h3>
                </div>
                <div className="technology">
                  <ul
                    data-aos="fade-up"
                    data-aos-offset="200"
                    data-aos-duration="600"
                    data-aos-once="true"
                    data-aos-easing="ease-in-sine"
                  >
                    <li>
                      <img src={Tech01} alt="" />
                    </li>
                    <li>
                      <img src={Tech02} alt="" />
                    </li>
                    <li>
                      <img src={Tech03} alt="" />
                    </li>
                    <li>
                      <img src={Tech04} alt="" />
                    </li>
                    <li>
                      <img src={Tech05} alt="" />
                    </li>
                    <li>
                      <img src={Tech06} alt="" />
                    </li>
                    <li>
                      <img src={Tech07} alt="" />
                    </li>
                    {/* <li><img src={Tech08} alt='' /></li> */}
                    <li>
                      <div>
                        <img style={{ maxWidth: "100%" }} src={Tech09} alt="" />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Jujharcont />
      {/* <Contactform /> */}
      <Footer />
    </>
  );
};
export default Home;
